import _get from 'lodash.get';

export const getAffiliatesFeedPlatform = (isMobile, frmApp) => {
  let platform = 'web';

  if (isMobile) {
    platform = 'mweb';
    if (frmApp) {
      platform = 'app';
    }
  } else if (frmApp) {
    platform = 'webapp';
  }

  return platform;
};
export function gdprCallback(resolve, reject) {
  if (typeof window !== 'undefined') {
    const gdprCallbackFnRef = _get(
      window,
      'TimesGDPR.common.consentModule.gdprCallback',
    );
    if (gdprCallbackFnRef) {
      gdprCallbackFnRef(dataObj => {
        if (typeof resolve === 'function') {
          resolve(dataObj);
        }
      });
    } else if (typeof reject === 'function') {
      reject();
    }
  }
}

export const geoCallback = gdprCallback;
